import React, { useState } from "react";
import WmModals from "../../modals/Wm.Modals";
import MyRespond from "../../posts/MyRespond";
import axios from "axios";
import API_ENDPOINT from "../../wm.api.service";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import Moment from "react-moment";
import parse from "html-react-parser";
const cookies = new Cookies();
function EditComment({ commentData, getOnlySpecificContent }) {
  // console.log("commentData", commentData);
  var token = cookies.get("wmtoken");
  const [editModal, setEditModal] = useState(false);
  const [editComment, setEditComment] = useState(commentData.comment);
  const post = (e, postId) => {
    var fd = new FormData();
    if (token) {
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
      fd.append("comment_id", postId);
      fd.append("content", editComment);
      axios({
        method: "post",
        url: `${API_ENDPOINT.apiURL}Profile/updateComment`,
        data: fd,
      })
        .then(function (response) {
          getOnlySpecificContent("COMMENT",0);
          setEditModal(false);
        })
        .catch(function (error) {
          console.log(error.response);
        });
    }
  };
  const deleteAnswer = (postId) => {
    var fd = new FormData();
    if (token) {
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
      fd.append("field_id", postId);
      fd.append("field_name", "COMMENT");
      axios({
        method: "post",
        url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
        data: fd,
      })
        .then(function (response) {
          getOnlySpecificContent("COMMENT",0);
          setEditModal(false);
        })
        .catch(function (error) {
          console.log(error.response);
        });
    }
  };
  return (
    <>
      <div className="col-md-12 mb-3">
        <div
          className="commentsEditContainer border rounded-lg p-3 cursor-pointer bg-white"
          onClick={() => setEditModal(true)}
        >
          <span className="text-xl manpro font-semibold block">
            {commentData.title}
          </span>
          <div className="flex">
            <div className="mr-2">
              <span className="manpro text-xs text-gray-400">
                Commented{" "}
                <span className="font-semibold manpro text-gray-500">
                  <Moment unix fromNow>
                    {commentData.created_on}
                  </Moment>
                </span>
              </span>
            </div>
            <div>
              {commentData.last_updated && (
                <span className="manpro text-xs text-gray-400">
                  Updated{" "}
                  <span className="font-semibold manpro text-gray-500">
                    <Moment unix fromNow>
                      {commentData.last_updated}
                    </Moment>
                  </span>
                </span>
              )}
            </div>
          </div>
          <div className="mt-3">
            <span className="text-base manpro font-medium block manpro">
              {commentData.comment && parse(commentData.comment)}
            </span>
          </div>
        </div>
      </div>
      <WmModals show={editModal} onHide={() => setEditModal(false)} size="lg">
        <div className="container-fluid py-3">
          <div className="row border-b border-gray-400 border-solid">
            <div className="col-md-6">
              <span className="manpro text-2xl font-semibold block ">
                Edit Comment
              </span>
            </div>
            <div className="col-md-6">
              <div className="text-right">
                <a
                  href={`${API_ENDPOINT.redirectURL}/${commentData.type_of_post}s/${commentData.url}`}
                  className="inline-block manpro rounded text-white py-1 px-3 mb-2 no-underline"
                  style={{backgroundColor: "var(--color-25)"}}
                >
                  View Post
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="commentEditContainer my-4">
                <MyRespond
                  value={editComment}
                  onChange={(e) => setEditComment(e.target.value)}
                  onClick={(e) => post(e, commentData.comment_id)}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="commentEditContainer border-t border-gray-400 border-solid text-right">
                <button
                  onClick={() => deleteAnswer(commentData.comment_id)}
                  className="cancelEdit px-4 py-1 rounded mt-3 text-white mr-3 bg-red-500"
                >
                  Delete
                </button>
                <button
                  onClick={() => setEditModal(false)}
                  className="cancelEdit px-3 py-1 rounded mt-3"
                  style={{ border: "1px solid var(--color-5)" }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </WmModals>
    </>
  );
}

export default EditComment;
